/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, OnInit, EventEmitter, Output, Input, ViewChild} from '@angular/core';
import {Router} from '@angular/router';

import {EmGroup} from '../models/em-group';
import {GroupType} from '../models/group-type';
import {GroupService} from '../services/group.service';
import { ERROR_DIALOG_TITLE, SimpleSuccessErrorDialogComponent } from './simple-success-error-dialog-box/simple-success-error-dialog-box.component';

declare var $: any;

@Component({
  selector: 'app-manage-groups-dialog',
  templateUrl: './manage-groups-dialog.component.html'
})
export class ManageGroupsDialogComponent implements OnInit {
  
  groupType: GroupType;
  
  mGroups: GroupUI[] = [];
  
  mGroup: EmGroup = null;

    /** Reference to the SimpleSuccessErrorDialog used to display error */
    @ViewChild('successErrorDialog') 
    simpleSuccessErrorDialogComponent: SimpleSuccessErrorDialogComponent;
  
  constructor(
    private mRouter: Router,
    private mGroupService: GroupService
  ) {}


  ngOnInit(): void {
    
  }
  
  show(groupType: GroupType): void {
    this.groupType = groupType;
    this.mGroup = null;
    $("#groupForm").slideUp();
    if (this.groupType != null) {
      this.refreshGroups(true);
    }
  }
  
  hide(): void {
    $("#manage-groups-dialog").modal("hide");
  }
  
  refreshGroups(displayDialog: boolean): void {
    this
      .mGroupService
      .getAllGroupsForGroupType(this.groupType)
      .then(
        result => {
          const groups: GroupUI[] = [];
          result.forEach(group => {
            const ui = new GroupUI();
            ui.mSelected = false;
            ui.mGroup = group;
            groups.push(ui);
          });
          this.mGroups = groups;
          if (displayDialog) {
            $("#manage-groups-dialog").modal("show");
          }
        },
        error => this.handleError(error)
      );
  }
  
  isSingleGroupSelected(): boolean {
    let selected = false;
    for (const group of this.mGroups) {
      if (group.mSelected) {
        if (selected) {
          return false;
        } else {
          selected = true;
        }
      }
    }
    return selected;
  }
  
  isAnyGroupsSelected(): boolean {
    return this.mGroups.some(group => group.mSelected);
  }
  
  editSelectedGroup(): void {
    if (this.isSingleGroupSelected()) {
      const selectedGroup = this.getSelectedGroups()[0];
      this.mGroup = JSON.parse(JSON.stringify(selectedGroup));
      $("#groupForm").slideDown();
    }
  }
  
  deleteSelectedGroups(): void {
    if (this.isAnyGroupsSelected()) {
      const groupIds: number[] = [];
      this.getSelectedGroups().forEach(group => groupIds.push(group.id));
      this
        .mGroupService
        .deleteGroups(groupIds)
        .then(
          result => {
            this.refreshGroups(false);
          },
          error => this.handleError(error)
        )
    }
  }
  
  getSelectedGroups(): EmGroup[] {
    const rv: EmGroup[] = [];
    this.mGroups.forEach(group => {
      if (group.mSelected) {
        rv.push(group.mGroup);
      }
    });
    return rv;
  }
  
  addNewGroupClicked(): void {
    if (this.mGroup != null && this.mGroup.id == null) {
      $("#groupForm").slideUp();
      this.mGroup = null;
    } else {
      const newGroup = new EmGroup();
      newGroup.type = this.groupType;
      newGroup.name = "";
      newGroup.description = "";
      this.mGroup = newGroup;
      $("#groupForm").slideDown();
    }
  }
  
  addGroupClicked(): void {
    if (this.mGroup != null && this.mGroup.id == null) {
      this
        .mGroupService
        .createGroup(this.mGroup)
        .then(
          success => {
            //Hide the "Add New Group" Form and refresh the group list...
            $("#groupForm").slideUp();
            this.mGroup = null;
            this.refreshGroups(false);
          },
          error => this.handleError(error)
        );
    }
  }
  
  updateGroupClicked(): void {
    if (this.mGroup != null && this.mGroup.id != null) {
      this
        .mGroupService
        .updateGroup(this.mGroup)
        .then(
          success => {
            $("#groupForm").slideUp();
            this.mGroup = null;
            this.refreshGroups(false);
          },
          error => this.handleError(error)
        );
    }
  }
  
  
  
  
  
  handleError(error: any): void {
    console.error("ManageGroupsDialogComponent.handleError() - Error: " + error);
    if (error?.error != null) {
      this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, error.error);
    }
    else if (error != null) {
      const response: Response = error;
      alert(response.text());
    }
  }

}

class GroupUI {
  mSelected: boolean;
  mGroup: EmGroup;
}
